import { gql } from 'graphql-request'

export namespace TicketMutations {
  export function createTicket() {
    return gql`
      mutation createTicket($ticket: TicketMutation, $attachments: [Upload!]) {
        createTicket(ticket: $ticket, attachments: $attachments) {
          id
          origin
          priority
          subject
          ticketType
          ticketReason
          internalTicketStatus
          marketSegment {
            name
          }
          assignee {
            id
            fullName
          }
          contact {
            id
            fullName
          }
          createdAt
          description
          reservationId
          homeId
          parentTicketId
          permissionToEnter
        }
      }
    `
  }

  export function updateTicket() {
    return gql`
      mutation updateTicket($ticket: TicketUpdateMutation) {
        updateTicket(ticket: $ticket) {
          id
          parentTicketId
        }
      }
    `
  }

  export function assignTickets() {
    return gql`
      mutation assignTickets($ticketIds: [Int!], $userId: Int!) {
        assignTickets(ticketIds: $ticketIds, userId: $userId)
      }
    `
  }

  export function createTicketAttachments() {
    return gql`
      mutation createAttachments($recordType: AttachmentRecordType!, $recordId: Int!, $attachments: [Upload!]) {
        createAttachments(recordType: $recordType, recordId: $recordId, attachments: $attachments) {
          id
        }
      }
    `
  }
}
